export default {"src":"/_next/static/media/dining.5ca8d13f.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};